import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { SketchPicker } from 'react-color';
import Popover from '@material-ui/core/Popover';
import AppContext from '../../AppContext';

class ColorPicker extends Component {
    constructor(props) {
        super(props);
        let color = this.parseColorFromProps(props);
        this.state = {
            displayColorPicker: false,
            background: color,
        };
    }

    componentDidUpdate(prevState) {
        if (prevState.color !== this.props.color) {
            this.updateColor(this.props);
        }
    }

    updateColor = (props) => {
        let color = this.parseColorFromProps(props);
        this.setState({ background: color });
    }

    parseColorFromProps = (props) => {
        let color = '#B3B3B3';
        if (props.color) {
            if (props.color.indexOf('#') !== -1) {
                color = props.color;
            } else if (props.color.indexOf('rgba') !== -1) {
                let rgba = props.color;
                let aux = rgba.substring(5, rgba.length - 1)
                    .replace(/ /g, '')
                    .split(',');
                color = {
                    r: aux[0],
                    g: aux[1],
                    b: aux[2],
                    a: aux[3],
                };
            }
        }
        // console.log('color from props', color)
        return color;
    }

    handleClick = (event) => {
        this.setState({ displayColorPicker: !this.state.displayColorPicker, anchorEl: event.currentTarget });
    };

    handleClose = () => {
        this.setState({ displayColorPicker: false, anchorEl: null });
    };

    handleChange = (color) => {
        //let newColor = `rgba(${color.rgb.r}, ${color.rgb.g}, ${color.rgb.b}, ${color.rgb.a})`;//color.hex;
        this.setState({ background: color.rgb });
    };

    handleChangeComplete = (color) => {
        if (this.props.handleColorChange) {
            let newColor = `rgba(${color.rgb.r}, ${color.rgb.g}, ${color.rgb.b}, ${color.rgb.a})`;//color.hex;
            this.props.handleColorChange(newColor);
        }
    };

    render() {
        const styles = {
            color: {
                width: '15px',
                height: '15px',
                borderRadius: '50%',
                background: ((typeof this.state.background) === 'string') ?
                    this.state.background
                    :
                    `rgba(${this.state.background.r}, ${this.state.background.g}, ${this.state.background.b}, ${this.state.background.a})`,
            },
            swatch: {
                padding: '5px',
                background: '#fff',
                borderRadius: '1px',
                boxShadow: '0 0 0 1px rgba(0,0,0,.3)',
                display: 'inline-block',
                cursor: 'pointer',
                verticalAlign: 'top'
            },
            container: {
                display: 'inline-block',
                verticalAlign: 'middle',
                position: 'relative',
                margin: '5px',
            }
        };

        let appContext = new AppContext();
        let platformConfig = appContext.getPlatformConfig();
        let presetColors = platformConfig !== undefined ? platformConfig.corporateColors : [];

        return (
            <div style={styles.container}>
                <div style={styles.swatch} onClick={this.handleClick} >
                    <div style={styles.color} />
                </div>
                <Popover
                    open={this.state.displayColorPicker && !this.props.disabled}
                    anchorEl={this.state.anchorEl}
                    onClose={this.handleClose}
                    anchorOrigin={{
                        vertical: 'bottom',
                        horizontal: 'center',
                    }}
                    transformOrigin={{
                        vertical: 'top',
                        horizontal: 'center',
                    }}
                >
                    <SketchPicker
                        disableAlpha={false}
                        color={this.state.background}
                        onChange={this.handleChange}
                        onChangeComplete={this.handleChangeComplete}
                        presetColors={presetColors} />
                </Popover>
            </div>
        );
    }
}
ColorPicker.propTypes = {
    color: PropTypes.string,
    handleColorChange: PropTypes.func,
    disabled: PropTypes.bool,
};

export default ColorPicker;